import { useQuery } from "@tanstack/react-query";
import api from "../api";
import { sampleReportKeys } from "../queryKeys";

const useYaraStringMatches = (hash: string, yaraTestRunResultId?: number) => {
  const yaraStringMatchesQuery = useQuery({
    queryKey: sampleReportKeys.getYaraStringMatches(hash, yaraTestRunResultId),
    queryFn: () => api.getYaraStringMatches(hash, yaraTestRunResultId)
  });

  return {
    data: yaraStringMatchesQuery.data?.data,
    isLoading: yaraStringMatchesQuery.isPending,
    error: yaraStringMatchesQuery.error
  };
};

export default useYaraStringMatches;
